import { gql } from '@apollo/client';

const GET_CLASSROOM_NAME = gql`
  query getClassroomName($id: Int!) {
    classroom(where: { id: $id }) {
      name
    }
  }
`;

export default GET_CLASSROOM_NAME;
